import React, { Component } from 'react';

import couterpart from 'counterpart';
import "react-table/react-table.css";
import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderDataService from '../services/WorkOrderDataService';
import { FaRecycle, FaSave, FaSync } from 'react-icons/fa';
import { ICON_COLOR } from '../icon';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import MasterDataService from '../services/MasterDataService';
import { DHL_NOTE_PREFIX, WO_BONG, WO_QUAYKIM, WO_SHIP_FROMVN, WO_TOBE_FIXED, WO_VOBAO, WO_XI } from '../constants';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import ItemDataService from '../services/ItemDataService';

class ShipDHLList extends Component {
    constructor() {
        super();
        this.state = {
            dhlByShipTo: [],
            labelValues: {},
            sumOfLabelValues: 0,
            showDetails: false,
            detailsItems: [],
            allStatus: [],
        };
        this.refsArray = {};
    };

    componentDidMount() {

        MasterDataService.retrieveAllStatus().then(data => {
            this.setState({ allStatus: data })
        });
        this.loadDHL();
    }

    compareOrder(a, b) {
        // converting to uppercase to have case-insensitive comparison
        const name1 = a.order;
        const name2 = b.order;

        let comparison = 0;

        if (name1 > name2) {
            comparison = 1;
        } else if (name1 < name2) {
            comparison = -1;
        }
        return comparison;
    }


    compareNhomOrder(a, b) {
        // converting to uppercase to have case-insensitive comparison
        let comparison = 0;
        if (a.length <= 0 || b.length <= 0) {
            return comparison;
        }
        const name1 = a[0].sortOrder;
        const name2 = b[0].sortOrder;


        if (name1 > name2) {
            comparison = 1;
        } else if (name1 < name2) {
            comparison = -1;
        }
        return comparison;
    }


    loadDHL() {
        WorkOrderDataService.retrieveDHL().then(data => {
            if (data !== undefined && data !== null) {
                let labelValues = {};
                let dhlByShipTo = [];
                Object.keys(data).forEach(function (key) {
                    let order = 0;
                    if (key === 'VN') {
                        order = 999
                    } else if (key === 'Úc') {
                        order = 2
                    } else if (key === 'CHÂU ÂU' || key === 'Châu Âu' || key === 'CHAU AU') {
                        order = 3
                    } else if (key === 'Mỹ' || key === 'MỸ' || key === 'MY') {
                        order = 1
                    }

                    dhlByShipTo.push({
                        shipTo: key,
                        dhl: data[key],
                        order: order,
                        in: 0
                    });

                    ///const keys = Object.keys(data[key]);
                    //for (let i = 0; i < keys.length; i++) {
                    //    //console.log(i + ":" + keys[i]);
                    //    labelValues[key + "_" + keys[i]] = i + 200;
                    //}
                });

                dhlByShipTo.sort(this.compareOrder);

                ItemDataService.findKvBy("labelValues").then(kv => {
                    let labelValuesAsString = kv.details;
                    let sum = 0;
                    if (labelValuesAsString !== undefined && labelValuesAsString !== null && labelValuesAsString.trim().length > 0){
                        labelValues = JSON.parse(labelValuesAsString);
                        sum = this.sumDelta(labelValues);
                    } else {
                        let labelValuesAsString = WorkOrderUtil.getItemFromStorage('labelValues');
                        if (labelValuesAsString !== undefined && labelValuesAsString !== null && labelValuesAsString.trim().length > 0){
                            labelValues = JSON.parse(labelValuesAsString);
                            sum = this.sumDelta(labelValues);
                        }
                    }
                    this.setState({
                        dhlByShipTo: dhlByShipTo,
                        labelValues: labelValues,
                        sumOfLabelValues: sum
                    });
                });
            }
        });
    }

    getBgColor(shipTo) {
        let a = {
            "Mỹ": "red",
            "Úc": "#ADD8E6",
            "Anh": "magenta",
            "Mỹ QT": "#DFFF00",
            "VN": "#CCCCFF"
        };
        if (a[shipTo]) {
            return a[shipTo];
        }
        return "magenta";
    }

    calculateDelta(shipTo, labelValue){
        let ishipTo = 0;
        if (this.isNotANumber(shipTo)){
            ishipTo = 0;
        } else {
            ishipTo = parseInt(shipTo);
        }
        if (this.isNotANumber(labelValue)){
            return 0 - ishipTo;
        }
        return parseInt(labelValue) - ishipTo;
    }

    isNotANumber(vl){
        if (vl === undefined || vl === null || vl === '' || isNaN(vl)){
            return true;
        }
        return false;
    }

    sumDelta(labelValues){
        let sum = 0;
        const keys = Object.keys(labelValues);
        for (let i = 0; i < keys.length; i++) {
           sum += parseInt(this.isNotANumber(labelValues[keys[i]])? 0 : labelValues[keys[i]]);
        }
        return sum;
    }

    handleChange(e){
        var name = e.target.name;
        console.log("name=" + name);
        if (name === undefined){
            return;
        }

        var value = e.target.value;
        console.log("value=" + value);
        if (value === undefined || isNaN(value)){
            value = 0;
        }

        let labelValues = this.state.labelValues;
        labelValues[name] = value;

        let sum = this.sumDelta(labelValues);
        this.setState({ labelValues:  labelValues, sumOfLabelValues: sum});
    }

    saveLabelValues(){
        let labelValues = this.state.labelValues;
        //WorkOrderUtil.saveItemToStorage('labelValues', JSON.stringify(labelValues));
        ItemDataService.saveKV("labelValues", JSON.stringify(labelValues));
    }

    renderDHLForAShipTo(dhlInfo, index) {

        if (dhlInfo === null || dhlInfo === undefined) {
            return (<></>);
        }

        var dhlByNhom = [];
        let labelKeyPrefix = dhlInfo.shipTo + "_";
        const keys = Object.keys(dhlInfo.dhl);
        var labelSum = 0;
        for (let i = 0; i < keys.length; i++) {
            dhlByNhom.push(dhlInfo.dhl[keys[i]]);
            let labelValue = this.state.labelValues[labelKeyPrefix + dhlInfo.dhl[keys[i]][0].nhom];
            labelSum += this.isNotANumber(labelValue)? 0 : parseInt(labelValue);
        }

        console.log(labelSum);

        dhlByNhom.sort(this.compareNhomOrder);

        var sumOfs = this.sumWoBy(dhlByNhom);
        

        //console.log("dhlByNhom", dhlByNhom);

        return (
            <table border="1" cellPadding="0" cellSpacing="0" width="100%" style={{ marginBottom: "50px" }} key={index}>
                <tbody>
                    <tr style={{ backgroundColor: this.getBgColor(dhlInfo.shipTo) }} >
                        <td className="text-left" style={{ paddingLeft: "20px" }}>
                            <b>{dhlInfo.shipTo} </b>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table border="1" cellPadding="2" cellSpacing="2" width="100%">
                                <tbody>
                                    <tr>
                                        <th className="text-center" style={{ backgroundColor: "orange" }}>
                                            {'STT'}
                                        </th>
                                        <th width="30%" className="text-center" style={{ backgroundColor: "orange" }}>
                                            {'Danh sách hàng'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "yellow" }}>
                                            {'Bóng'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "yellow" }}>
                                            {'Kim'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "yellow" }}>
                                            {'Xi'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "yellow" }}>
                                            {'Lỗi Xi'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "yellow" }}>
                                            {'Vô bao'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "green" }}>
                                            {'Ship From VN'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "green", width: "170px"  }}>
                                            {'Label'} &nbsp;&nbsp;
                                            <button variant="primary" onClick={this.saveLabelValues.bind(this)} className="myButton">
                                                <FaSave color={ICON_COLOR} />&nbsp;{couterpart.translate('button_save')}
                                            </button>
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "green", width: "170px" }}>
                                            {'Chênh lệch Label vs Ship From VN'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "green", width: "170px" }}>
                                            {'TRỌNG LƯỢNG (KG)/CÁI'}
                                        </th>
                                        <th className="text-center" style={{ backgroundColor: "green", width: "170px" }}>
                                            {'TRỌNG LƯỢNG TỔNG'}
                                        </th>
                                    </tr>
                                    {
                                        dhlByNhom.map((item, index) => {
                                            //console.log(item, index);
                                            // console.log(item[0].nhom);
                                            return (
                                                <tr key={item[0].nhom + "_" + index}>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{index + 1}</label>
                                                    </td>
                                                    <td className="text-left" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{item[0].nhom}</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{this.linkToDetails(this.getNumOfWoBy(item, 41))}</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{this.linkToDetails(this.getNumOfWoBy(item, 42))}</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{this.linkToDetails(this.getNumOfWoBy(item, 43))}</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{this.linkToDetails(this.getNumOfWoBy(item, 54))}</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{this.linkToDetails(this.getNumOfWoBy(item, 44))}</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{this.linkToDetails(this.getNumOfWoBy(item, 45))}</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <input name={dhlInfo.shipTo + "_" + item[0].nhom} id={dhlInfo.shipTo + "_" + item[0].nhom}
                                                            type="text" size="5" style={{ textAlign: "right"}} placeholder="" defaultValue={this.state.labelValues[dhlInfo.shipTo + "_" + item[0].nhom]} onChange={this.handleChange.bind(this)}/>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{this.calculateDelta(this.getNumOfWoBy(item, 45).num, this.state.labelValues[dhlInfo.shipTo + "_" + item[0].nhom]) }</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{ item[0].kl }</label>
                                                    </td>
                                                    <td className="text-right" style={{ paddingRight: "10px" }}>
                                                        <label className="label_link">{ item[0].kl * this.getNumOfWoBy(item, 45).num }</label>
                                                    </td>
                                                </tr>);
                                        })
                                    }

                                    <tr>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "orange" }}>

                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "orange" }}>
                                            &nbsp;Tổng số
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "yellow" }}>
                                            <label className="label_sum">{sumOfs.bong}</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "yellow" }}>
                                            <label className="label_sum">{sumOfs.kim}</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "yellow" }}>
                                            <label className="label_sum">{sumOfs.xi}</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "yellow" }}>
                                            <label className="label_sum">{sumOfs.loi}</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "yellow" }}>
                                            <label className="label_sum">{sumOfs.vobao}</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "green" }}>
                                            <label className="label_sum">{sumOfs.shipVN}</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "pink" }}>
                                            <label className="label_sum">{labelSum}</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "#bde0fe" }}>
                                            <label className="label_sum">{labelSum - sumOfs.shipVN}</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "#bde0fe" }}>
                                            <label className="label_sum">{ sumOfs.kl }</label>
                                        </td>
                                        <td className="text-right" style={{ paddingRight: "10px", backgroundColor: "#bde0fe" }}>
                                            <label className="label_sum">{ sumOfs.klt }</label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <table border="1" cellPadding="2" cellSpacing="2" width="100%">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '5%' }}>
                                            Ghi chú:
                                        </td>
                                        <td style={{ width: '82%' }}>
                                            <textarea id="dhlInfo.shipTo"
                                                ref={ref => {
                                                    // Callback refs are preferable when 
                                                    // dealing with dynamic refs
                                                    this.refsArray[dhlInfo.shipTo] = ref;
                                                }}
                                                name={dhlInfo.shipTo} rows="4" cols="250" style={{ width: '100%' }}></textarea>
                                        </td>
                                        <td style={{ width: '23%' }}>
                                            <button variant="primary" onClick={this.clearText.bind(this, dhlInfo.shipTo)} className="myButton">
                                                <FaRecycle color={ICON_COLOR} />&nbsp;{couterpart.translate('button_clear')}
                                            </button>
                                            <button variant="primary" onClick={this.loadText.bind(this, dhlInfo.shipTo)} className="myButton">
                                                <FaSync color={ICON_COLOR} />&nbsp;{couterpart.translate('button_reload')}
                                            </button>
                                            <button variant="primary" onClick={this.storeText.bind(this, dhlInfo.shipTo)} className="myButton">
                                                <FaSave color={ICON_COLOR} />&nbsp;{couterpart.translate('button_save')}
                                            </button>
                                        </td>
                                        {this.loadText(dhlInfo.shipTo)}
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    clearText(shipTo) {
        this.refsArray[shipTo].value = '';
    }

    storeText(shipTo) {
        //WorkOrderUtil.saveItemToStorage(DHL_NOTE_PREFIX + shipTo, this.refsArray[shipTo].value);
        ItemDataService.saveDHLNoteBy(shipTo, this.refsArray[shipTo].value);
    }

    loadText(shipTo) {
        //this.refsArray[shipTo].value = WorkOrderUtil.getItemFromStorage(DHL_NOTE_PREFIX + shipTo);
        ItemDataService.findDHLNoteBy(shipTo).then(data => {
            if (data !== undefined && data !== null) {
                this.refsArray[shipTo].value = data.details;
            }
        });
    }

    handleDHL(dhl) {
        WorkOrderDataService.retrieveDHLDetailsBy(dhl.nhom, dhl.status, dhl.shipTo).then(data => {
            if (data !== undefined && data !== null) {
                this.handleShowDetails(data);
            }
        });
    }

    linkToDetails(dhl) {
        return (
            <label className="label_link" href="#!" onClick={() => { this.handleDHL(dhl) }}>{dhl.num}</label>
        )
    }

    getNumOfWoBy(item, status) {
        let filtered = item.filter(x => x.status === status);
        let num = 0;
        let nhom = "";
        let shipTo = "";
        for (let i = 0; i < filtered.length; i++) {
            //console.log(filtered[i]);
            num += filtered[i].numOfWo;
            nhom = filtered[i].nhom;
            shipTo = filtered[i].shipTo;
        }

        return {
            num,
            nhom,
            shipTo,
            status
        };
    }

    sumWoBy(dhlByNhom) {
        let bong = 0;
        let kim = 0;
        let xi = 0;
        let loi = 0;
        let vobao = 0;
        let shipVN = 0;
        let kl = 0;
        let klt = 0;

        for (let i = 0; i < dhlByNhom.length; i++) {
            bong += this.getNumOfWoBy(dhlByNhom[i], WO_BONG).num;
            kim += this.getNumOfWoBy(dhlByNhom[i], WO_QUAYKIM).num;
            xi += this.getNumOfWoBy(dhlByNhom[i], WO_XI).num;
            loi += this.getNumOfWoBy(dhlByNhom[i], WO_TOBE_FIXED).num;
            vobao += this.getNumOfWoBy(dhlByNhom[i], WO_VOBAO).num;
            let numShip = this.getNumOfWoBy(dhlByNhom[i], WO_SHIP_FROMVN).num;
            shipVN += numShip;
            if (dhlByNhom[i].length > 0){
                let klNum = dhlByNhom[i][0].kl; 
                kl += klNum;
                klt += klNum * numShip
            }
        }
        return {
            bong,
            kim,
            xi,
            loi,
            vobao,
            shipVN,
            kl,
            klt
        };
    }

    renderDHLList() {
        if (this.state.dhlByShipTo === undefined || this.state.dhlByShipTo === null || !(this.state.dhlByShipTo instanceof Array)) {
            return (<></>);
        }

        return (<>
            {
                this.state.dhlByShipTo.map((item, index) => {
                    return this.renderDHLForAShipTo(item, index);
                })
            }
        </>
        );
    }

    refeshDhl() {
        this.loadDHL();
    }

    handleDetailsClose() {
        this.setState({
            showDetails: false,
            detailsItems: []
        });
    }

    handleShowDetails(data) {
        this.setState({
            showDetails: true,
            detailsItems: data
        });
    }

    getStatusDescription(status) {
        if (this.state.allStatus === undefined || this.state.allStatus === null) {
            return status;
        }
        let istatus = parseInt(status);
        let statusInfo = this.state.allStatus.find(x => {
            return x.status === istatus;
        });
        if (statusInfo !== undefined) {
            return statusInfo.statusDescVn;
        }
        return status;
    }

    renderShops() {
        if (this.state.detailsItems === undefined || this.state.detailsItems === null || !(this.state.detailsItems instanceof Array)) {
            return (<></>);
        }
        return (
            <table border="1" cellPadding="2" cellSpacing="2" width="100%">
                <tbody>
                    <tr>
                        <th>
                            {'Stt'}
                        </th>
                        <th>
                            {'ShipTo'}
                        </th>
                        <th>
                            {'Nhóm'}
                        </th>
                        <th>
                            {'Số đơn hàng'}
                        </th>
                        <th>
                            {'Mã sản xuất'}
                        </th>
                        <th>
                            {'Sku'}
                        </th>
                        <th>
                            {'Tình trạng'}
                        </th>
                        <th>
                            {'Độ ưu tiên'}
                        </th>
                    </tr>
                    {this.state.detailsItems.map((dhl, index) => {
                        console.log(dhl);
                        if (index % 2 === 0) {
                            return (
                                <tr style={{ backgroundColor: "lightblue" }} key={dhl.Sku + "_" + index}>
                                    <td>
                                        <label className="label_link">{index + 1}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.shipTo}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.nhom}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.workOrderNo}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.fullPCode}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.sku}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{this.getStatusDescription(dhl.status)}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.sortOrder}</label>
                                    </td>
                                </tr>
                            )
                        } else {
                            return (
                                <tr style={{ backgroundColor: "white" }} key={dhl.Sku + "_" + index}>
                                    <td>
                                        <label className="label_link">{index + 1}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.shipTo}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.nhom}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.workOrderNo}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.fullPCode}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.sku}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{this.getStatusDescription(dhl.status)}</label>
                                    </td>
                                    <td>
                                        <label className="label_link">{dhl.sortOrder}</label>
                                    </td>
                                </tr>
                            )
                        }
                    })
                    }
                </tbody>
            </table>)
    }

    render() {
        if (!AuthenticationService.isShipping()) {
            return (<div>Unauthorized access.</div>);
        }
        return (
            <div>
                <div className='row' style={{ margin: '20px' }}>
                    <div className='col-12'>
                        <button variant="primary" onClick={this.refeshDhl.bind(this)} className="myButton">
                            <FaSync color={ICON_COLOR} />&nbsp;{couterpart.translate('button_refesh')}
                        </button>
                    </div>
                </div>
                <div className="row" style={{ margin: "20px" }}>
                    <div className="col-12">
                        {this.renderDHLList()}
                    </div>
                </div>

                <Modal show={this.state.showDetails} onHide={this.handleDetailsClose.bind(this)} backdrop="static" dialogClassName="modal-90w">
                    <Modal.Header closeButton>
                        <Modal.Title>Thông tin Chi tiết</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-12">
                                {this.renderShops()}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleDetailsClose.bind(this)}>Đóng</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default ShipDHLList;
